import {get, post} from "services/BaseClient/Client"
import endPoints from "apps/Account/EndPoints"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import { ForgotPasswordForm, ResetPasswordForm, TokenEmail } from "./Modesl";




export const getTokenWithEmail = async (data: any): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.getToken}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data, config);
  };
  export const registerUser = async (data: any): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.registerUser}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data, config);
  };


  export const forgotPassword = async (data: ForgotPasswordForm): Promise<DataResponse<ForgotPasswordForm>> => {
    const url = `${endPoints.forgotPassord}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data, config);
  }

  export const resetPassword = async (data: ResetPasswordForm): Promise<DataResponse<ResetPasswordForm>> => {
    const url = `${endPoints.setPassord}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<ResetPasswordForm>>(url, data, config);
  }

  export const activateVerification = async (data: any): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.activateVerification}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data, config);
  };
  export const getVerifiactionInfoes = async (): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.getVerificationInfo}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getExternalEIDS = async (data:any): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.eids}?yetkiKodu=${data.yetkiKodu}&durum=${data.durum}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getUserCode = async (data:any): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.getUserCode}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  };


  export const getIndividualContract = async (): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.getIndividualContract}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getUserInfoesByPhoneNumber = async (numberPrefix:string,numberBody:string): Promise<DataResponse<TokenEmail>> => {
    const url = `${endPoints.getUserInfoByPhoneNumber}${numberPrefix}/${numberBody}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

 

  export const getSMSVerifyCode = async (prefix:string,body:string): Promise<DataResponse<any>> => {
    const url = `${endPoints.getSMSCode}${prefix}/${body}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const getExternalLogin = async (provider:string,redirectUrl:string): Promise<DataResponse<any>> => {
    const url = `${endPoints.getExternalLogin}?provider=${provider}&returnUrl=${redirectUrl}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };